import React from "react";
import styles from "./postDetailComponent.module.scss";
import Link from "next/link";
import { IBaseBox } from "../../model/base";
interface HotNewsProps {
  title: string;
  items: IBaseBox[];
}
export function HotNews(props: HotNewsProps) {
  const { title, items } = props;
  return (
    <div className={styles["block-topic"]}>
      <div className={styles["h3"]}>
      <span style={{ cursor: "default", color: "#007bff" }}>{title}</span>
      </div>
      <div className={styles.content}>
        {items &&
          items.slice(0, 2).map((item, index) => (
            <div className={styles.item} key={index}>
              <p>
                <Link href={`/${item.alias}`} title={item.title}>
                  {item.title}
                </Link>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
